
























































































import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import { userService } from "../../_services/user-service";
import * as user from "@/_store/user.module";

@Component
export default class RateDialog extends Vue {
    @Prop({ required: true }) info!: any;
    private dialog: boolean = false;
    private localRating: number = 0;
    private localNota: string = '';
    private saving: boolean = false;

    get canEditRating(): boolean {
        const userInfo = user.readUserInfo(this["$store"]);
        return userInfo && (userInfo.ruoloUtente.includes(2) || (userInfo.ruoloUtente.includes(10) && this.info.idTutorFormativo === userInfo.idUtente));
    }

    openModal() {
        // Controlla se l'attività è terminata prima di aprire il modal
        if (this.info.idStatoAccettazione !== 4) {
            bus.$emit("errorOperation", "La valutazione è disponibile solo per attività terminate");
            return;
        }

        this.localRating = this.info.rating || 0;
        this.localNota = this.info.notaRating || '';
        this.dialog = true;
    }

    closeModal() {
        this.dialog = false;
        this.localRating = 0;
        this.localNota = '';
        this.saving = false;
    }

    async saveModal() {
        if (!this.localRating || !this.canEditRating) return;

        this.saving = true;
        try {
            var payload = {
                idInformazioneAlternanza: this.info.idInfoAlternanza,
                rating: this.localRating,
                notaRating: this.localNota
            };

            await user.dispatchRateAlternanza(this["$store"], payload)
                .then(response => {
                    bus.$emit("loadPreAssegnazioni");
                    bus.$emit("successfullOperation", "Rating salvato con successo");
                    this.closeModal();
                })
                .catch(error => {
                    if (error.response.status === 403) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                    } else {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    }
                });
        } catch (error) {
            console.error("Errore nel salvataggio del rating:", error);
            bus.$emit("errorOperation", "Errore nel salvataggio del rating");
        } finally {
            this.saving = false;
        }
    }
}
